export default "__VITE_ASSET__PEosB3QK__"